var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('resource',{attrs:{"resource":"asa","resourceName":"ASA","attributes":[
      {
        name: 'days',
        label: 'Tage'
      },
      {
        name: 'hours',
        label: 'Stunden'
      },
      {
        name: 'minutes',
        label: 'Minuten'
      },
      {
        name: 'tolerance',
        label: 'Toleranz (in Minuten)'
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("ASA erstellen")])])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-info"},[_c('p',[_vm._v("\n      Eine Asa ist ein Wiederanschreiben eines Mitglieds, nach dem dieses\n      Mitglied bereits in einem Dialog geschrieben hat, aber nicht mehr\n      antwortet. Sprich, die Moderation hat die letzte Nachricht geschrieben.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Eine Asa Stufe entspricht einer Nachricht. Das heißt, Wenn im System\n      eine ASA Stufe eingetragen ist, wird das Mitglied nach der letzten\n      Nachricht eines Moderators ein weiteres Mal angeschrieben. Bei 10 ASA\n      Stufen wird das Mitglied 10 Mal erneut angeschrieben.\n    ")])])
}]

export { render, staticRenderFns }